module.exports = __webpack_public_path__ + "img/creditcard.ad6a0756.svg";